import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import {
  Box,
  Grid,
  Toolbar,
  Paper,
  Typography,
  AppBar,
  Tooltip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  theme,
  StyledSearch,
  StyledSearchIconWrapper,
  StyledInputBase,
  StyledButtonReload,
  StylePaperButton,
} from "./Styled-EntradaMercancias";
import Cookies from "js-cookie";
import { Header, MenuLateral } from "../Header/Header";
import {
  addEntradaMercancia,
  DetalleEntradaMercancia,
} from "../Data/EntradasMercancia-Data";
import { UpdateAccessToken } from "../Router/Cookies";
import EntradaMercanciasTabla from "./EntradaMercanciasTabla";
import { FormatoMoneda } from "../Data/DatosSAT";
import CircularProgress from "@mui/material/CircularProgress";

function EntradaMercancias(props) {
  const [filtro, setFiltro] = React.useState("");
  const [cargar, setCargar] = React.useState(true);
  const { entradaMercancias, setEntradaMercancias } = props;

  const usuario = Cookies.get("usuario");
  const operador = Cookies.get("operador");
  const id = Cookies.get("id");
  const access = Cookies.get("access");
  const IsSession = !!Cookies.get("access");

  React.useEffect(() => {
    fetchData(setEntradaMercancias);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async (setEntradaMercancias) => {
    setEntradaMercancias([]);
    const Values = {
      usuario: id,
      operador: operador,
    };
    const Peticion = new Request(
      "/api/entradasMercancia/getEntradasMercancia",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "x-access-token": access,
        },
        method: "POST",
        body: JSON.stringify(Values),
      }
    );

    let DatosArray = [];
    try {
      setCargar(true);
      const response = await fetch(Peticion);
      const data = await response.json();
      const Datos = data.data;

      Datos.map((item) =>
        DatosArray.push(
          addEntradaMercancia(
            item.Fila,
            item.Fila,
            item.U_SYS_PMSNBD,
            item.CardName,
            item.DocNum,
            item.Pedido,
            item.DocStatus,
            item.DocDate,
            item.DocDueDate,
            item.GroupNum,
            item.U_B1SYS_MainUsage,
            item.GroupNum > 0 ? "PPD" : "PUE",
            item.PeyMethod,
            FormatoMoneda(parseFloat(item.DocTotal)),
            item.NumAtCard,
            item.Comments,
            item.DiscPrcnt,
            item.DiscSum,
            item.VatSum,
            item.U_SYS_PMDPDF,
            item.BD,
            item.DocCur ? item.DocCur : "",
            item.DetalleEntradaMercancia.map((itemDetalle) =>
              DetalleEntradaMercancia(
                itemDetalle.IdPedido,
                itemDetalle.Fila,
                itemDetalle.ItemName,
                itemDetalle.FrgnName,
                itemDetalle.LineStatus,
                itemDetalle.UomCode,
                itemDetalle.Quantity,
                item.GroupNum,
                item.U_B1SYS_MainUsage,
                item.GroupNum > 0 ? "PPD" : "PUE",
                parseFloat(itemDetalle.PriceBefDi).toFixed(2),
                itemDetalle.DiscPrcnt,
                itemDetalle.LineTotal
              )
            )
          )
        )
      );

      setEntradaMercancias(DatosArray);
    } catch (error) {
      console.error(error);
    }
    setCargar(false);
  };

  const handleForma = (event) => {
    event.preventDefault();
    fetchData(setEntradaMercancias);
  };

  if (!UpdateAccessToken()) {
    return <Navigate to="/" />;
  } else
    return (
      <ThemeProvider theme={theme}>
        <Box
          sx={{
            display: "flex",
          }}
        >
          <Header
            IsSession={IsSession}
            open={props.open}
            setOpen={props.setOpen}
            operador={operador}
            usuario={usuario}
          />
          <MenuLateral
            IsSession={IsSession}
            open={props.open}
            setOpen={props.setOpen}
          />
          <Box
            sx={{
              flexGrow: 10,
              height: "100vh",
              overflow: "auto",
            }}
          >
            <Toolbar />

            <Typography
              color="text.secondary"
              align="center"
              variant="h4"
              component="h4"
              margin={2}
            >
              Entradas de mercancía
            </Typography>
            <Paper sx={{ maxWidth: "90%", margin: "auto", overflow: "hidden" }}>
              <AppBar
                position="static"
                sx={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }}
              >
                <Toolbar>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs>
                      <StyledSearch>
                        <StyledSearchIconWrapper>
                          <SearchIcon />
                        </StyledSearchIconWrapper>
                        <StyledInputBase
                          placeholder="Search…"
                          inputProps={{ "aria-label": "search" }}
                          value={filtro}
                          onChange={(e) => setFiltro(e.target.value)}
                        />
                      </StyledSearch>
                    </Grid>
                    <Grid>
                      <Tooltip title="Recargar">
                        <StyledButtonReload
                          color="inherit"
                          onClick={handleForma}
                          size="medium"
                        >
                          <RefreshIcon
                            id="btnRefreshEmpleado"
                            color="inherit"
                            sx={{ display: "block" }}
                          />
                        </StyledButtonReload>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Toolbar>
                {
                  <EntradaMercanciasTabla
                    filtro={filtro}
                    rows={entradaMercancias}
                  />
                }
                <StylePaperButton>
                  {cargar === true && <CircularProgress />}
                </StylePaperButton>
              </AppBar>
            </Paper>
          </Box>
        </Box>
      </ThemeProvider>
    );
}

EntradaMercancias.propTypes = {
  entradaMercancias: PropTypes.array,
};

export default EntradaMercancias;
